import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { MessagingMessageEntity } from './messaging-message.entity';
import { MessagingParticipantEntity } from './messaging-participant.entity';

@Entity('_messaging_delivery')
@Index(
	'idx_messaging_delivery_message_participant',
	['messageId', 'participantId'],
	{ unique: true },
)
export class MessagingDeliveryEntity extends BaseEntity {
	@Column({
		name: 'fk_messaging_message__id',
		type: 'int',
		unsigned: true,
		nullable: false,
	})
	@Index()
	public messageId!: number;

	@ManyToOne(() => MessagingMessageEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'CASCADE',
	})
	@JoinColumn({
		name: 'fk_messaging_message__id',
		referencedColumnName: 'id',
	})
	public message?: MessagingMessageEntity;

	@Column({
		name: 'fk_messaging_participant__id',
		type: 'int',
		unsigned: true,
		nullable: false,
	})
	@Index()
	public participantId!: number;

	@ManyToOne(() => MessagingParticipantEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'CASCADE',
	})
	@JoinColumn({
		name: 'fk_messaging_participant__id',
		referencedColumnName: 'id',
	})
	public participant?: MessagingParticipantEntity;

	@Column({
		name: 'provider',
		type: 'varchar',
		length: 50,
		nullable: false,
	})
	public provider!: string;

	@Column({
		name: 'provider_message_id',
		type: 'varchar',
		length: 255,
		nullable: true,
	})
	@Index()
	public providerMessageId?: string;

	@Column({
		name: 'status',
		type: 'varchar',
		length: 50,
		nullable: false,
	})
	public status!: string;

	@Column({
		name: 'queued_at',
		type: 'timestamp',
		nullable: true,
	})
	public queuedAt?: Date;

	@Column({
		name: 'sent_at',
		type: 'timestamp',
		nullable: true,
	})
	public sentAt?: Date;

	@Column({
		name: 'delivered_at',
		type: 'timestamp',
		nullable: true,
	})
	public deliveredAt?: Date;

	@Column({
		name: 'read_at',
		type: 'timestamp',
		nullable: true,
	})
	public readAt?: Date;

	@Column({
		name: 'failed_at',
		type: 'timestamp',
		nullable: true,
	})
	public failedAt?: Date;

	@Column({
		name: 'error_message',
		type: 'text',
		nullable: true,
	})
	public errorMessage?: string;

	@Column({
		name: 'error_code',
		type: 'varchar',
		length: 100,
		nullable: true,
	})
	public errorCode?: string;

	@Column({
		name: 'provider_data',
		type: 'json',
		nullable: true,
	})
	public providerData?: Record<string, unknown>;
}
